import { useQuery } from "@tanstack/react-query"
import { useApi } from "../../../../hooks/useApi"
import { TagAssignmentMap } from "../../../../../api/tags"

const useTagAssignments = () => {
  const { scientApi } = useApi()

  return useQuery({
    queryKey: ["tagAssignmentsByInstrument"],
    queryFn: () => scientApi.tags.getAssignmentsByInstrument(),
    staleTime: 60_000,
  })
}

export default useTagAssignments

/** Look up a tag value for a given instrument and tag group */
export const getTagValueForInstrument = (
  assignmentMap: TagAssignmentMap | undefined,
  instrumentId: number | null,
  tagGroupId: number
): string | null => {
  if (!assignmentMap || instrumentId == null) return null
  const instrTags = assignmentMap[String(instrumentId)]
  if (!instrTags) return null
  return instrTags[String(tagGroupId)] ?? null
}
